import type { TenantConfig, TenantRegistry } from '../types'

import { uplatformConfig } from './uplatform.config'
import { winfinityConfig } from './winfinity.config'

/**
 * Реестр всех доступных конфигураций тенантов
 */
export const tenantRegistry: TenantRegistry = {
  winfinity: winfinityConfig,
  uplatform: uplatformConfig,
}

/**
 * Получить конфигурацию тенанта по ID
 * @param tenantId - идентификатор тенанта
 * @returns конфигурация тенанта или конфигурация по умолчанию
 */
export function getTenantConfig(tenantId: string): TenantConfig {
  const config = tenantRegistry[tenantId]

  if (!config) {
    console.warn(`Tenant configuration for "${tenantId}" not found. Using default.`)
    return tenantRegistry.uplatform
  }

  return config
}

/**
 * Проверить, существует ли тенант
 * @param tenantId - идентификатор тенанта
 */
export function tenantExists(tenantId: string): boolean {
  return tenantId in tenantRegistry
}

/**
 * Получить список всех доступных тенантов
 */
export function getAvailableTenants(): string[] {
  return Object.keys(tenantRegistry)
}
